import { useMemo } from "react";

import { IntegrationCompleteStatuses } from "@intelligems/ig-types";

import { useConfiguration } from "@src/api/configurations/use-configuration";

import { useGetOrg } from "@src/api/organizations/get-organization";

export const useIsPriceTestIntegrationReady = () => {
  const organization = useGetOrg();
  const isHeadless = useConfiguration("is_headless_storefront");
  const priceSelectors = useConfiguration<string[]>(
    "additional_price_query_selectors"
  );

  return useMemo(
    () =>
      Boolean(
        IntegrationCompleteStatuses.includes(
          organization.data.org.integrationStatus
        ) ||
        (priceSelectors?.value || []).length > 0 ||
        isHeadless?.value
      ),
    [organization.data.org.integrationStatus, priceSelectors, isHeadless?.value]
  );
};
